import { InjectionToken } from '@angular/core';

export const RESPONSE_CACHE_WEBWORKER_FACTORY = new InjectionToken<() => Worker>(
    'response-cache.worker'
);
